import type { JSX } from 'react';

import type { AlertActivityItem } from '../../model/activity';

interface AlertActivityContentProps {
  item: AlertActivityItem;
}

const AlertActivityContent = ({ item }: AlertActivityContentProps): JSX.Element => (
  <div className="flex flex-col gap-1.5">
    {item.messageText ? (
      <p className="m-0 line-clamp-2 text-sm text-text-default font-body">{item.messageText}</p>
    ) : (
      <p className="m-0 text-sm text-text-subtle font-body italic">Sin texto de alerta</p>
    )}
    {item.identifier ? (
      <span className="inline-flex w-fit items-center rounded bg-red-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-red-900">
        {item.identifier}
      </span>
    ) : null}
  </div>
);

export default AlertActivityContent;
